import { memo } from 'react';

import { LogIn } from 'lucide-react';
import { Link } from 'react-router-dom';

import { PATHS } from '@/constants/page-paths';
import { useSettingsStore } from '@/store';
import { Button } from '../ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';

export const LoginDialog = memo(() => {
  const { setShowLoginPrompt, showLoginPrompt, loginPromptMessage } =
    useSettingsStore();
  return (
    <Dialog open={showLoginPrompt} onOpenChange={setShowLoginPrompt}>
      <DialogContent
        className="sm:max-w-[420px] p-6 rounded-lg"
        onInteractOutside={(e) => e.preventDefault()}
      >
        <div className="flex flex-col items-center space-y-6">
          <DialogHeader className="text-center">
            <div className="flex flex-col items-center space-y-4">
              <div className="rounded-full bg-secondary p-3 shadow-md">
                <LogIn className="h-6 w-6 text-primary" aria-hidden="true" />
              </div>
              <DialogTitle className="text-xl font-semibold">
                Sign In
              </DialogTitle>
              <DialogDescription className="text-muted-foreground text-center">
                {loginPromptMessage}
              </DialogDescription>
            </div>
          </DialogHeader>

          <DialogFooter className="flex flex-col sm:flex-row w-full gap-3">
            <Link to={PATHS.REGISTER} className="w-full">
              <Button
                className="w-full"
                variant="secondary"
                onClick={() => setShowLoginPrompt(false)}
                data-testid="limit-dialog-register-button"
                aria-label="Create a new account"
              >
                Create Account
              </Button>
            </Link>
            <Link to={PATHS.SIGN_IN} className="w-full">
              <Button
                className="w-full"
                onClick={() => setShowLoginPrompt(false)}
                data-testid="limit-dialog-signin-button"
                aria-label="Sign in to existing account"
              >
                Sign In
              </Button>
            </Link>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
});
